/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Board_Empty_StageInputs */

const cs_tasks_board_empty_stage = /** @type {(inputs: Tasks_Board_Empty_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V této fázi nejsou žádné úkoly.`)
};

const en_tasks_board_empty_stage = /** @type {(inputs: Tasks_Board_Empty_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tasks in this stage.`)
};

/**
* | output |
* | --- |
* | "No tasks in this stage." |
*
* @param {Tasks_Board_Empty_StageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_board_empty_stage = /** @type {((inputs?: Tasks_Board_Empty_StageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Board_Empty_StageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_board_empty_stage(inputs)
	return cs_tasks_board_empty_stage(inputs)
});